import { Input } from 'components/Form/components/Input/input.styles';
import styled, { css, rem, screenMobilePlusAndSmaller } from 'theme';

export const IbanInput = styled(Input)`
  padding: 0 ${rem(16)};

  &::placeholder {
    font-family:
      var(--ref-font-family-diodrum),
      Open Sans,
      sans-serif;
    font-weight: var(--ref-font-weight-400);
  }
`;

export const BankCodeSuggestions = styled('div')`
  display: flex;
  flex-direction: column;
  grid-column: 2;

  ${screenMobilePlusAndSmaller(css`
    grid-column: 1;
  `)}
`;

export const BankCode = styled('span')`
  cursor: pointer;
  display: inline-block;
  width: ${rem(65)};
  height: ${rem(30)};
  line-height: ${rem(30)};
  border-radius: ${rem(43)};
  background-color: var(--ref-color-blackwhite-white);
  text-align: center;
  margin-left: ${rem(5)};
  font-size: ${rem(12)};
  border: var(--sys-border-width-xs) solid var(--ref-color-gray-20);

  &:hover {
    color: var(--sys-color-primary);
    font-weight: var(--ref-font-weight-600);
  }
`;
